import { useState } from "react";
import {categoriesModel} from "../entity/categories/CategoryModel";
import { ICategory } from "../entity/categories/ICategory";
import { deleteCategoryUseCase } from "../useCases/deleteCategoryUseCase";
import { useNavigate } from "react-router-dom";
import { updateCategoryUseCase } from "../useCases/updateCategoryUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";
import { findCategory } from "src/utils/Utils";

export const useCategoryListItem = (category: ICategory) => {
    const { t } = useUiContext();
    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const navigate = useNavigate();

    const categories = categoriesModel.categories;

    const parent = findCategory(categories, category?.parent_id);

    const handleOpenMenu = (event) => {
        setOpenMenu(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setOpenMenu(null);
    };

    const onOpenCloseAccordion = () => {
        setOpen(!open);
    };

    const onEdit = () => {
        navigate(`/dashboard/categories/edit/${category.id}`);
    };

    const onCreateSerialCategory = () => {
        navigate(`/dashboard/categories/create/?parentId=${category.id}`);
    }

    const onActiveSwitch = async () => {
        const result: any = await updateCategoryUseCase({ id: category.id, available: !category.available });
        if (!result?.isError) {
            toastService.onSuccess(t('categories.message.categoryAccessSwitched'));
        }
    };

    const onDelete = async () => {
        await deleteCategoryUseCase(category.id);
    }

    return { parent, onDelete, open, onOpenCloseAccordion, handleOpenMenu, openMenu, handleCloseMenu, onEdit, onCreateSerialCategory, onActiveSwitch };

}